import React from 'react';
import { Route, Redirect, IndexRedirect } from 'react-router';
import { withApollo } from 'react-apollo';
import App from './containers/App';

import CorpList from './containers/corporations/List';
import FeedList from './containers/feeds/List';
import ParseReport from './containers/feeds/ParseReport';
import CustomerList from './containers/customers/List';
import BuilderList from './containers/builders/List';
import SubdivisionList from './containers/subdivisions/List';
import LotList from './containers/lots/List';
import GetReport from './containers/reports/Get';

import ErrorPage from './components/ErrorPage';

export default (
	<Route path="/" component={App}>
		<IndexRedirect to="corporations" />
		<Route path="corporations" component={CorpList} />
		<Route path="corporations/:corpId" component={BuilderList} />
		<Redirect from="corporations/:corpId/builders" to="corporations/:corpId" />
		<Route path="corporations/:corpId/builders/:builderId" component={SubdivisionList} />
		<Redirect
			from="corporations/:corpId/builders/:builderId/subdivisions"
			to="corporations/:corpId/builders/:builderId"
		/>
		<Route
			path="corporations/:corpId/builders/:builderId/subdivisions/:subdivisionId"
			component={withApollo(LotList)}
		/>
		<Route path="feeds" component={FeedList} />
		<Route path="feeds/:feedId" component={ParseReport} />
		<Route path="customers" component={CustomerList} />
		<Route path="reports" component={withApollo(GetReport)} />
		<Route path="access-denied" component={ErrorPage} errorCode="401" />
		<Route path="forbidden" component={ErrorPage} errorCode="403" />
		<Route path="*" component={ErrorPage} errorCode="404" />
	</Route>
);



// WEBPACK FOOTER //
// ./src/assets/js/routes.js